const CheckUserRight = (rights: any, rightName: string) => {
    var CREATE = 0x1; // 0001
    var READ = 0x2; // 0010
    var EDIT = 0x4; // 0100
    var DELETE = 0x8; // 1000

    return {
        create: Boolean(rights[rightName] & CREATE),
        read: Boolean(rights[rightName] & READ),
        edit: Boolean(rights[rightName] & EDIT),
        delete: Boolean(rights[rightName] & DELETE)
    };
};

export default CheckUserRight;